/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_G3_DInputs */

const en_mk_sec_pg_g3_d = /** @type {(inputs: Mk_Sec_Pg_G3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agent cannot reach the internet unless you switch it on for that agent.`)
};

const id_mk_sec_pg_g3_d = /** @type {(inputs: Mk_Sec_Pg_G3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen tidak bisa menjangkau internet kecuali Anda menyalakannya untuk agen itu.`)
};

/**
* | output |
* | --- |
* | "An agent cannot reach the internet unless you switch it on for that agent." |
*
* @param {Mk_Sec_Pg_G3_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_g3_d = /** @type {((inputs?: Mk_Sec_Pg_G3_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_G3_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_g3_d(inputs)
	return en_mk_sec_pg_g3_d(inputs)
});